import React from 'react';
const bonuses = [{
  id: '01',
  title: 'PACK DE STICKERS, TARJETAS Y SEPARADORES MOTIVACIONALES',
  subtitle: '',
  description: 'Recursos imprimibles para regalar a tus alumnos, pegar en cuadernos y reforzar la convivencia positiva en el aula.',
  value: '$6.000',
  features: ['+60 stickers ilustrados de convivencia, emociones y ciudadanía digital', 'Tarjetas motivacionales para regalar', 'Separadores escolares con frases e ilustraciones para cuadernos', 'Insignias y coronas de buena conducta', 'Versión color + versión para colorear', 'Todo listo para imprimir y recortar']
}, {
  id: '02',
  title: 'KIT DE IMPLEMENTACIÓN EXPRESS',
  subtitle: '7 días para activar tu sistema de convivencia escolar',
  description: 'Una hoja de ruta clara para activar el sistema en tu escuela en exactamente una semana, sin perderse ni improvisar.',
  value: '$6.000',
  features: ['Hoja de ruta de 7 días paso a paso', 'Checklist de arranque institucional', 'Agenda de primera reunión interna', 'Tracker de seguimiento mensual', 'Resumen ejecutivo en una página']
}, {
  id: '03',
  title: 'PACK DE RECURSOS IMPRIMIBLES PARA ACCIÓN INMEDIATA',
  subtitle: 'Láminas · Checklists · Guías · Materiales para Familias',
  description: 'Todo listo para colgar en el aula, usar en la dirección y enviar a casa sin necesidad de diseñar nada.',
  value: '$6.000',
  features: ['Guía rápida de crisis para el escritorio', 'Circuito de derivación institucional', 'Acta de intervención lista para completar', 'Checklist del docente ante incidente', 'Semáforo de convivencia para el aula', 'Lámina de derechos del alumno', 'Folletos para enviar a las familias']
}];
export function Bonuses() {
  return <section className="bg-[#F5F5F5] py-6 md:py-12 lg:py-[60px]" data-id="element-1">
      <div className="container mx-auto px-4" data-id="element-2">
        <div className="text-center mb-5 md:mb-6 lg:mb-8" data-id="element-3">
          <h2 className="text-[#1B3A6B] font-poppins font-black text-3xl md:text-5xl mb-3" data-id="element-4">
            🎁 3 BONOS ESTRATÉGICOS
          </h2>
          <p className="text-[#555555] text-lg" data-id="element-5">
            Valor total bonos: $18.000 →{' '}
            <span className="text-[#FF6B35] font-bold" data-id="element-6">GRATIS con tu pack</span>
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-3 md:gap-5 lg:gap-6 max-w-6xl mx-auto" data-id="element-7">
          {bonuses.map(b => <div key={b.id} className="bg-white p-5 md:p-6 lg:p-8 rounded-[16px] shadow-[0_2px_20px_rgba(0,0,0,0.08)] relative flex flex-col" data-id="element-8">
              <div className="flex flex-wrap items-center gap-2 mb-4" data-id="element-9">
                <span className="px-3 py-1 rounded-full text-xs font-bold text-white bg-[#FF6B35] font-poppins" data-id="element-10">
                  BONO {b.id}
                </span>
                <span className="px-3 py-1 rounded-full text-xs font-bold text-white bg-[#2D9B6F] font-poppins" data-id="element-11">
                  GRATIS
                </span>
                <span className="text-[#555555] text-sm line-through opacity-60 font-medium" data-id="element-12">
                  {b.value}
                </span>
              </div>

              <h3 className="text-[#1B3A6B] font-poppins font-bold text-lg md:text-xl mb-2 leading-tight" data-id="element-13">
                {b.title}
              </h3>

              {b.subtitle && <p className="text-[#FF6B35] font-poppins font-bold text-sm mb-3" data-id="element-14">
                  {b.subtitle}
                </p>}

              <p className="text-[#555555] text-sm mb-4 leading-relaxed" data-id="element-15">
                {b.description}
              </p>

              <ul className="space-y-2 mt-auto" data-id="element-16">
                {b.features.map((f, i) => <li key={i} className="flex items-start gap-2 text-sm" data-id="element-17">
                    <span className="text-[#2D9B6F] font-bold shrink-0 mt-0.5" data-id="element-18">
                      ✅
                    </span>
                    <span className="text-[#2C2C2C]" data-id="element-19">{f}</span>
                  </li>)}
              </ul>
            </div>)}
        </div>
      </div>
    </section>;
}